/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Full_Dark_Finch_SingInputs */

const en_full_dark_finch_sing = /** @type {(inputs: Full_Dark_Finch_SingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} o'Clock`)
};

const de_full_dark_finch_sing = /** @type {(inputs: Full_Dark_Finch_SingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} Uhr`)
};

/**
* | output |
* | --- |
* | "{date} o'Clock" |
*
* @param {Full_Dark_Finch_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_dark_finch_sing = /** @type {((inputs: Full_Dark_Finch_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Dark_Finch_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_dark_finch_sing(inputs)
	return de_full_dark_finch_sing(inputs)
});